import { generatePath } from "react-router-dom";

export const path = {
  list: {
    route: "/my-staff",
    link: () => path.list.route,
  },
  view: {
    route: "/my-staff/view/:id",
    link: (id: string) => generatePath("/my-staff/view/:id", { id }),
  },
};
